import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import {
    getAuthenticatedHomePath,
    isAuthOnlyPath,
    resetNavigationHistory,
} from '../utils/nativeBackNavigation';

interface NativeAuthRouteGuardProps {
    isAuthenticated: boolean;
}

/**
 * If a logged-in user lands on login (e.g. iOS edge-swipe history), redirect home immediately.
 */
const NativeAuthRouteGuard: React.FC<NativeAuthRouteGuardProps> = ({ isAuthenticated }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!Capacitor.isNativePlatform() || !isAuthenticated) {
            return;
        }
        if (!isAuthOnlyPath(location.pathname)) {
            return;
        }

        const home = getAuthenticatedHomePath();
        resetNavigationHistory(home);
        navigate(home, { replace: true });
    }, [isAuthenticated, location.pathname, navigate]);

    return null;
};

export default NativeAuthRouteGuard;
